export const CONTEXT_LINK_FIELDS = {
	ID: 'id',
	LABEL: 'label',
	URL: 'url',
	// OPEN_IN_NEW_TAB: 'openInNewTab'
};
